import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiDownload, FiX } from 'react-icons/fi';
import './WebinarStatsModal.css';
import './QuizStatsModal.css';

const QuizStatsModal = ({ open, onClose, webinarId }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open && webinarId) {
      fetchStats();
    }
  }, [open, webinarId]);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/webinars/${webinarId}/quiz/stats/`);
      setStats(response.data);
    } catch (error) {
      toast.error('Ошибка загрузки статистики ответов');
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      const response = await axios.get(`/api/webinars/${webinarId}/quiz/export/`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `quiz_webinar_${webinarId}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Данные выгружены');
    } catch (error) {
      toast.error('Ошибка выгрузки данных');
    }
  };

  if (!open) return null;

  const formatAnswer = (answer) => {
    if (!answer) return '—';
    const selected = (answer.selected_options || []).join(', ');
    return selected || answer.text_answer || '—';
  };

  return (
    <div className="stats-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="stats-modal-content">
        <div className="stats-modal-header">
          <h2>Статистика ответов</h2>
          <button className="stats-modal-close" onClick={onClose}>
            <FiX />
          </button>
        </div>
        <div className="stats-modal-body">
          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : stats ? (
            <>
              <div className="stats-summary">
                <div className="stat-summary-item">
                  <h3>Ответов получено</h3>
                  <p className="stat-value">{stats.total_responses || 0}</p>
                </div>
                <div className="stat-summary-item">
                  <h3>Вопросов</h3>
                  <p className="stat-value">{(stats.questions || []).length}</p>
                </div>
              </div>

              {(stats.questions || []).length > 0 && (
                <div className="quiz-stats-questions">
                  {(stats.questions || []).map((question) => (
                    <div key={question.id} className="quiz-stats-question">
                      <h3>{question.text}</h3>
                      <div className="quiz-stats-meta">
                        {question.share_link_name} · {question.question_type === 'text' ? 'Свой ответ' : question.question_type === 'multiple' ? 'Несколько вариантов' : 'Один вариант'}
                      </div>
                      {question.question_type === 'text' ? (
                        <p className="quiz-stats-hint">Текстовые ответы смотрите в таблице ниже</p>
                      ) : (
                        <div className="quiz-stats-options">
                          {(question.options || []).map((option) => (
                            <div key={option.id} className="quiz-stats-option">
                              <span>{option.text}</span>
                              <strong>{option.count || 0}</strong>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              <div className="stats-actions">
                <button className="btn btn-primary" onClick={handleExport}>
                  <FiDownload /> Выгрузить ответы (CSV)
                </button>
              </div>

              {(stats.responses || []).length > 0 ? (
                <div className="registrations-table-container">
                  <h3>Ответы зрителей</h3>
                  <div className="registrations-table">
                    <table>
                      <thead>
                        <tr>
                          <th>Фамилия</th>
                          <th>Имя</th>
                          <th>Email</th>
                          <th>Ссылка</th>
                          <th>Дата</th>
                          {(stats.questions || []).map((question) => (
                            <th key={question.id}>{question.text}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {(stats.responses || []).map((item) => {
                          const answersByQuestion = {};
                          (item.answers || []).forEach((answer) => {
                            answersByQuestion[answer.question_id] = answer;
                          });
                          return (
                            <tr key={item.id}>
                              <td>{item.last_name}</td>
                              <td>{item.first_name}</td>
                              <td>{item.email || '—'}</td>
                              <td>{item.share_link_name}</td>
                              <td>{item.submitted_at ? new Date(item.submitted_at).toLocaleString('ru-RU') : '—'}</td>
                              {(stats.questions || []).map((question) => (
                                <td key={`${item.id}-${question.id}`}>{formatAnswer(answersByQuestion[question.id])}</td>
                              ))}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="empty-state">Пока никто не отправил ответы</div>
              )}
            </>
          ) : (
            <div className="empty-state">Нет данных</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuizStatsModal;
